// extracted by mini-css-extract-plugin
export default {"Pause-btn":"PauseBtn_Pause-btn__LZ4fu"};